import { BookOutlined, UserDeleteOutlined } from '@ant-design/icons';
import { endOfDay, startOfYear } from 'date-fns';
import * as Yup from 'yup';

import { EEnrolledSectionParticipantStatus } from '@/api/endpoints/schools/schoolSelectionPanel';

export const STUDENT_STATUS_TO_TAG_SETTINGS = {
  [EEnrolledSectionParticipantStatus.Accepted]: {
    text: 'Зачислен',
    color: 'blue',
    icon: <BookOutlined />,
  },
  [EEnrolledSectionParticipantStatus.Expelled]: {
    text: 'Отчислен',
    color: 'gray',
    icon: <UserDeleteOutlined />,
  },
};

export const EXPULSION_PARTICIPANT_VALIDATION_SCHEMA = Yup.object().shape({
  expulsionReason: Yup.string()
    .required('Обязательное поле')
    .max(250, 'Превышено максимальное число символов')
    .matches(/^\S(.*\S)?$/s, 'Поле не должно начинаться или заканчиваться пробелами'),
  expelledAt: Yup.date()
    .typeError('Некорректная дата')
    .required('Обязательное поле')
    .test('max-today', 'Дата не может быть позже текущей', (value) => !value || value <= endOfDay(new Date()))
    .test(
      'min-current-year',
      'Дата не может быть раньше текущего года',
      (value) => !value || value >= startOfYear(new Date()),
    ),
});
